import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as UserProvider } from './context/userContext';

// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import GoogleTagManager from './GoogleTagManager';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <UserProvider>
          <ThemeProvider>
            <GoogleTagManager />
            <ScrollToTop />
            <StyledChart />
            <Router />
          </ThemeProvider>
        </UserProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
